import React from 'react'
import SuperSearchList from '../../../../../../../../shared/SuperSearch/SuperSearchList';

const CurrentMentalStatus = ({ searchValueCMS, setSearchValueCMS, handleSelectedData, cmsDDData, is, setIs}) => {
  return (<div className="stratigy_rows">
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Orientation</label>
                            <SuperSearchList
                                type="client"
                                id='Orientation'
                                name='Orientation'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Orientation}
                                data={cmsDDData?.Orientation?.length > 0 ? cmsDDData?.Orientation : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Orientation: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Insight</label>
                            <SuperSearchList
                                type="client"
                                id='Insight'
                                name='Insight'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Insight}
                                data={cmsDDData?.Insight?.length > 0 ? cmsDDData?.Insight : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Insight: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>General Appearance</label>
                            <SuperSearchList
                                type="client"
                                id='GeneralAppearance'
                                name='GeneralAppearance'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.GeneralAppearance}
                                data={cmsDDData?.['GeneralAppearance'] ?.length > 0 ? cmsDDData?.['GeneralAppearance'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, GeneralAppearance: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Judgment/Impulse Control</label>
                            <SuperSearchList
                                type="client"
                                id='JudgementAndImpulseControl'
                                name='JudgementAndImpulseControl'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.JudgementAndImpulseControl}
                                data={cmsDDData?.['JudgementAndImpulseControl']?.length > 0 ? cmsDDData?.['JudgementAndImpulseControl'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, JudgementAndImpulseControl: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Dress</label>
                            <SuperSearchList
                                type="client"
                                id='Dress'
                                name='Dress'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Dress}
                                data={cmsDDData?.Dress?.length > 0 ? cmsDDData?.Dress : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Dress: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Memory</label>
                            <SuperSearchList
                                type="client"
                                id='Memory'
                                name='Memory'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Memory}
                                data={cmsDDData?.Memory?.length > 0 ? cmsDDData?.Memory : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Memory: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Motor Activity</label>
                            <SuperSearchList
                                type="client"
                                id='MotorActivity'
                                name='MotorActivity'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.MotorActivity}
                                data={cmsDDData?.['MotorActivity']?.length > 0 ? cmsDDData?.['MotorActivity'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, MotorActivity: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Attention/Concentration</label>
                            <SuperSearchList
                                type="client"
                                id='AttentionConcentration'
                                name='AttentionConcentration'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.AttentionConcentration}
                                data={cmsDDData?.['AttentionConcentration']?.length > 0 ? cmsDDData?.['AttentionConcentration'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, AttentionConcentration: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Interview Behaviour</label>
                            <SuperSearchList
                                type="client"
                                id='InterviewBehaviour'
                                name='InterviewBehaviour'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.InterviewBehaviour}
                                data={cmsDDData?.['InterviewBehaviour']?.length > 0 ? cmsDDData?.['InterviewBehaviour'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, InterviewBehaviour: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Thought Process</label>
                            <SuperSearchList
                                type="client"
                                id='ThoughtProcess'
                                name='ThoughtProcess'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.ThoughtProcess}
                                data={cmsDDData?.['ThoughtProcess']?.length > 0 ? cmsDDData?.['ThoughtProcess'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, ThoughtProcess: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Speech</label>
                            <SuperSearchList
                                type="client"
                                id='Speech'
                                name='Speech'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Speech}
                                data={cmsDDData?.Speech?.length > 0 ? cmsDDData?.Speech : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Speech: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Thought Content</label>
                            <SuperSearchList
                                type="client"
                                id='ThoughtContent'
                                name='ThoughtContent'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.ThoughtContent}
                                data={cmsDDData?.['ThoughtContent']?.length > 0 ? cmsDDData?.['ThoughtContent'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, ThoughtContent: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Mood</label>
                            <SuperSearchList
                                type="client"
                                id='Mood'
                                name='Mood'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Mood}
                                data={cmsDDData?.Mood?.length > 0 ? cmsDDData?.Mood : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Mood: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Perception</label>
                            <SuperSearchList
                                type="client"
                                id='Perception'
                                name='Perception'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Perception}
                                data={cmsDDData?.Perception?.length > 0 ? cmsDDData?.Perception : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Perception: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Affect</label>
                            <SuperSearchList
                                type="client"
                                id='Affect'
                                name='Affect'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.Affect}
                                data={cmsDDData?.Affect?.length > 0 ? cmsDDData?.Affect : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, Affect: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-0 align-items-end">
                <div className="col-md-12 px-0 row m-0">
                    <div className="col-md-4 ps-0">
                        <div className='input form-group ar-multiple-br m-0 w-100'>
                            <label>Functional Status</label>
                            <SuperSearchList
                                type="client"
                                id='FunctionalStatus'
                                name='FunctionalStatus'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValueCMS.FunctionalStatus}
                                data={cmsDDData?.['FunctionalStatus']?.length > 0 ? cmsDDData?.['FunctionalStatus'] : []}
                                onChange={(e) => { setIs(false); setSearchValueCMS(prev => ({ ...prev, FunctionalStatus: e.target.value })) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default CurrentMentalStatus